import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { MaskedLine, FadeUp } from "../components/Reveal";
import { api } from "../lib/api";

export default function InsightDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <section className="pt-40 pb-32 text-center" data-testid="insight-not-found">
        <p className="text-muted-foreground">Article not found.</p>
        <Link to="/insights" className="mt-4 inline-block text-sm font-semibold text-accent">Back to Insights</Link>
      </section>
    );
  }

  if (!post) return <section className="pt-40 pb-32 text-center text-sm text-muted-foreground">Loading…</section>;

  return (
    <article data-testid="insight-detail">
      <section className="pt-32 lg:pt-40 pb-12">
        <div className="mx-auto max-w-3xl px-6">
          <FadeUp>
            <Link to="/insights" data-testid="insight-back-link" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-accent transition-colors">
              <ArrowLeft size={16} /> All Insights
            </Link>
          </FadeUp>
          <FadeUp delay={0.1}>
            <div className="mt-8 flex items-center gap-3 text-xs">
              <span className="font-bold tracking-[0.15em] uppercase text-accent">{post.category}</span>
              <span className="text-muted-foreground">{post.date} · {post.read_time} · {post.author}</span>
            </div>
          </FadeUp>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl font-light tracking-tighter text-primary leading-[1.05]">
            <MaskedLine delay={0.15}>{post.title}</MaskedLine>
          </h1>
        </div>
      </section>
      <FadeUp delay={0.3}>
        <div className="mx-auto max-w-4xl px-6">
          <div className="overflow-hidden rounded-3xl border border-primary/10 aspect-[16/8]">
            <img src={post.image} alt={post.title} className="h-full w-full object-cover" />
          </div>
        </div>
      </FadeUp>
      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-3xl px-6 space-y-8">
          {post.body.map((para, i) => (
            <FadeUp key={i} delay={i * 0.05}>
              <p className={`leading-relaxed ${i === 0 ? "text-lg sm:text-xl text-foreground font-medium" : "text-base sm:text-lg text-muted-foreground"}`}>
                {para}
              </p>
            </FadeUp>
          ))}
        </div>
      </section>
    </article>
  );
}
